module.exports = "/packs/008-1230c20831b69fb52ea5ccad4d392f23.jpg";